module.exports = {"id":"211361","name":"Danilo Cataldi","rating":"75","photo":"./data/images/photos/4/211361.png","club":{"name":"Benevento","logo":"./data/images/clubs/Benevento.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DaniloCataldi0.json
// module id = 957
// module chunks = 0